module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-header container--fluid",
    attrs: {
      "id": "site-header",
      "context": "site-header"
    }
  }, [(_vm.cookieActive) ? _c('sk-snackbar', {
    attrs: {
      "top": (_vm.$breakpoints.xs ? false : true),
      "fixed": (_vm.$breakpoints.xs ? true : false),
      "multi-line": "",
      "fullwidth": true,
      "timeout": null
    },
    model: {
      value: (_vm.cookieActive),
      callback: function($$v) {
        _vm.cookieActive = $$v
      },
      expression: "cookieActive"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_vm._v("\n         We use cookies to improve your experience. By continuing on our website, you agree to this. "), _c('a', {
    attrs: {
      "href": "/content/legal/privacy-policy"
    }
  }, [_vm._v("Find more information on Ster-Kinekor's Privacy Policy")]), _vm._v(".\n        ")]), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeCookie($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Close\n          ")], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.$breakpoints.xs)) ? [(_vm.showUserActivation) ? _c('sk-snackbar', {
    attrs: {
      "top": (_vm.$breakpoints.xs ? false : true),
      "fixed": (_vm.$breakpoints.xs ? true : false),
      "multi-line": "",
      "fullwidth": true,
      "timeout": null
    },
    model: {
      value: (_vm.showUserActivation),
      callback: function($$v) {
        _vm.showUserActivation = $$v
      },
      expression: "showUserActivation"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs6": "",
      "grow": ""
    }
  }, [_c('b', [_vm._v("THANKS FOR CREATING A SK PROFILE!")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                    Please activate your account by checking your email for your verification link.\n                  ")])]), _vm._v(" "), _c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs6": "",
      "grow": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5px"
    }
  }, [_vm._v("Haven't received it?")]), _vm._v(" "), _c('sk-button', {
    staticClass: "btn--reactivate",
    attrs: {
      "small": "",
      "primary": "",
      "loading": _vm.activationLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resendVerification()
      }
    }
  }, [_vm._v("RESEND VERIFICATION EMAIL NOW")]), _vm._v(".\n                ")], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeVerificationSnack($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Close\n              ")], 1)], 1)], 1)], 1)], 1) : _vm._e()] : [((_vm.$breakpoints.md)) ? [(_vm.showUserActivation) ? _c('sk-snackbar', {
    attrs: {
      "top": (_vm.$breakpoints.xs ? false : true),
      "fixed": (_vm.$breakpoints.xs ? true : false),
      "multi-line": "",
      "fullwidth": true,
      "timeout": null
    },
    model: {
      value: (_vm.showUserActivation),
      callback: function($$v) {
        _vm.showUserActivation = $$v
      },
      expression: "showUserActivation"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs6": "",
      "grow": ""
    }
  }, [_c('b', [_vm._v("THANKS FOR CREATING A SK PROFILE!")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                        Please activate your account by checking your email for your verification link.\n                      ")])]), _vm._v(" "), _c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs6": "",
      "grow": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5px"
    }
  }, [_vm._v("Haven't received it?")]), _vm._v(" "), _c('sk-button', {
    staticClass: "btn--reactivate",
    attrs: {
      "small": "",
      "primary": "",
      "loading": _vm.activationLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resendVerification()
      }
    }
  }, [_vm._v("RESEND VERIFICATION EMAIL NOW")]), _vm._v(".\n                    ")], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeVerificationSnack($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Close\n                  ")], 1)], 1)], 1)], 1)], 1) : _vm._e()] : [(_vm.showUserActivation) ? _c('sk-snackbar', {
    attrs: {
      "top": (_vm.$breakpoints.xs ? false : true),
      "fixed": (_vm.$breakpoints.xs ? true : false),
      "multi-line": "",
      "fullwidth": true,
      "timeout": null
    },
    model: {
      value: (_vm.showUserActivation),
      callback: function($$v) {
        _vm.showUserActivation = $$v
      },
      expression: "showUserActivation"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs7": "",
      "grow": ""
    }
  }, [_c('b', [_vm._v("THANKS FOR CREATING A SK PROFILE!")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                        Please activate your account by checking your email for your verification link.\n                      ")])]), _vm._v(" "), _c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs5": "",
      "grow": ""
    }
  }, [_vm._v("\n                        Haven't received it? "), _c('sk-button', {
    staticClass: "btn--reactivate",
    attrs: {
      "small": "",
      "primary": "",
      "loading": _vm.activationLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resendVerification()
      }
    }
  }, [_vm._v("RESEND VERIFICATION EMAIL NOW")]), _vm._v(".\n                    ")], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeVerificationSnack($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Close\n                  ")], 1)], 1)], 1)], 1)], 1) : _vm._e()]], _vm._v(" "), _c('nav', {
    staticClass: "main-nav"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sm2": "",
      "md2": ""
    }
  }, [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _c('div', [_c('nav', {
    staticClass: "nav-header"
  }, [_c('sk-dialog', {
    attrs: {
      "transition": "sk-slide-x-transition",
      "fullscreen": "",
      "overlay": false,
      "lazy": ""
    },
    model: {
      value: (_vm.mobileNavActive),
      callback: function($$v) {
        _vm.mobileNavActive = $$v
      },
      expression: "mobileNavActive"
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.mobileNavActive = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-mobile--action",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('i', {
    staticClass: "icon icon-menu"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-mobile--target"
  }, [(_vm.guest) ? [_c('li', [_c('a', {
    attrs: {
      "href": "/user/signup",
      "tertiary": ""
    }
  }, [_vm._v("Create Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/user/login",
      "secondary": ""
    }
  }, [_vm._v("Sign In")])])] : _vm._e(), _vm._v(" "), (!_vm.guest) ? [_c('div', {
    staticClass: "member-login"
  }, [_c('sk-profile-toolbar', {
    attrs: {
      "user": _vm.user,
      "click-outside": "",
      "active": _vm.active
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.guest === false) ? _c('li', [
    [_c('a', {
      attrs: {
        "href": "/user/profile"
      }
    }, [_vm._v("My Dashboard")])]
  ], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.navItems), function(item) {
    return (item != undefined && item != null) ? [(item.topNav) ? _c('li', [(item.topNav) ? _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.path,
        "contextValue": "Header Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1) : _vm._e()] : _vm._e()
  }), _vm._v(" "), (_vm.guest === false) ? _c('li', [
    [_c('a', {
      attrs: {
        "href": "/user/sign-out"
      }
    }, [_vm._v("Sign Out")])]
  ], 2) : _vm._e()], 2)])], 1)]) : _c('div', {
    staticClass: "desktop-logo"
  }, [(!_vm.isNouveau.path) ? _c('a', {
    attrs: {
      "href": "/",
      "data-track-context": "Header Navigation",
      "data-track-value": "Nouveau"
    }
  }, [_c('img', {
    staticClass: "img-responsive logo",
    attrs: {
      "src": _vm.logoSrc
    }
  })]) : _c('a', {
    attrs: {
      "href": _vm.isNouveau.path,
      "data-track-context": "Header Navigation",
      "data-track-value": "Nouveau"
    }
  }, [_c('img', {
    staticClass: "img-responsive logo",
    attrs: {
      "src": _vm.logoSrc
    }
  })])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs8": "",
      "sm7": "",
      "md7": ""
    }
  }, [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _c('div', {
    staticClass: "mobile-logo"
  }, [_c('sk-button', {
    attrs: {
      "router": "",
      "tag": "a",
      "contextValue": "Header Navigation",
      "dataValue": "Nouveau",
      "to": _vm.isNouveau
    }
  }, [_c('img', {
    staticClass: "img-responsive logo",
    attrs: {
      "src": _vm.logoSrc
    }
  })])], 1) : _c('div', [_c('nav', {
    staticClass: "nav-header"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_vm._l((_vm.navItems), function(item) {
    return (item != undefined && item != null) ? [(item.topNav) ? _c('li', [(item.topNav) ? _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.path,
        "contextValue": "Header Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1) : _vm._e()] : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": "",
      "sm3": "",
      "md3": ""
    }
  }, [(_vm.$breakpoints.md || _vm.$breakpoints.lg || _vm.$breakpoints.lgUp) ? _c('div', [_c('sk-profile-toolbar', {
    attrs: {
      "user": _vm.user,
      "click-outside": "",
      "active": _vm.active,
      "guest": _vm.guest
    }
  })], 1) : _vm._e()])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-978a062c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/site-header/site-header.vue
// module id = 892
// module chunks = 0